export default __webpack_public_path__ + "static/char-s-14-chs-7cb90169d7da7815902094e69aaa3bd6.png";